import React from "react";
import { Box, Skeleton } from "@mui/material";
import PageContainer from "../PageContainer";
import CreateSectionHeader from "../CreateNotice/CreateSectionHeader";
import { CREATE_CARD_GRID_SX } from "../CreateNotice/createStyles";

export const SIGNATURE_CARD_HEIGHT = 160;

export const SignaturesHeader: React.FC = () => (
  <CreateSectionHeader
    crumbs={[]}
    title="Signatures"
    subtitle="The people who sign your certificates. Each Award picks who signs it."
  />
);

/** Placeholder cards shaped like Signature cards, shown while the list loads. */
export const SignatureCardsSkeleton: React.FC = () => (
  <Box role="status" aria-label="Loading Signatures" sx={CREATE_CARD_GRID_SX}>
    {[0, 1, 2].map((card) => (
      <Skeleton key={card} variant="rounded" height={SIGNATURE_CARD_HEIGHT} />
    ))}
  </Box>
);

/** The Signatures page while its code downloads: the header and grey cards. */
const SignaturesSkeleton: React.FC = () => (
  <PageContainer>
    <SignaturesHeader />
    <SignatureCardsSkeleton />
  </PageContainer>
);

export default SignaturesSkeleton;
